import {snakeCase, isPlainObject} from 'lodash';

export const verifyIsValidEncounterId = (lastQueryParam?: unknown) => {
    if (!lastQueryParam) return false;
    if (lastQueryParam === 'begin') return false;
    if (isNaN(Number(lastQueryParam))) return false;

    return true;
};

type RecordStringUnknown = Record<string, unknown>;

/**
 * DO NOT EXPORT OR USE THIS FUNCTION ANYWHERE ELSE!
 *
 * Recursively converts the keys of an object to snake_case.
 *
 * @param obj The object to convert.
 * @returns A new object with snake_cased keys.
 */
const convertKeysToSnakeCase = (obj: RecordStringUnknown) => {
    const snakeCaseObj: RecordStringUnknown = {};

    if (!isPlainObject(obj)) {
        return obj;
    }

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const snakeCaseKey = snakeCase(key);

            if (obj[key] === null) {
                snakeCaseObj[snakeCaseKey] = null;
            } else if (Array.isArray(obj[key])) {
                // TS should infer that obj[key] is an array of unknowns, but it doesn't
                snakeCaseObj[snakeCaseKey] = obj[key].map(arrayObj =>
                    convertKeysToSnakeCase(arrayObj as RecordStringUnknown),
                );
            } else if (isPlainObject(obj[key])) {
                snakeCaseObj[snakeCaseKey] = convertKeysToSnakeCase(
                    obj[key] as RecordStringUnknown,
                );
            } else {
                snakeCaseObj[snakeCaseKey] = obj[key];
            }
        }
    }

    return snakeCaseObj;
};

type LegacyData = {
    patientCodeStatus: RecordStringUnknown;
    organization: {
        reviewers: RecordStringUnknown[];
        encounterNoteConfig: RecordStringUnknown;
        modelOfCare: RecordStringUnknown;
    };
    deficits: RecordStringUnknown[];
    problems: RecordStringUnknown[];
    diagnoses: RecordStringUnknown[];
};

/**
 * DO NOT USE THIS FUNCTION ANYWHERE OTHER THAN FOR initReactProps!
 *
 * It is only used to map the keys of the legacy initReactProps data
 * to snake_case, and only where that mapping is needed.
 */
export const mapFieldCase = (data: LegacyData) => {
    return {
        ...data,
        deficits: data.deficits.map(deficit => convertKeysToSnakeCase(deficit)),
        diagnoses: data.diagnoses.map(diagnosis =>
            convertKeysToSnakeCase(diagnosis),
        ),
        organization: {
            ...data.organization,
            encounterNoteConfig: convertKeysToSnakeCase(
                data.organization.encounterNoteConfig,
            ),
            modelOfCare: convertKeysToSnakeCase(data.organization.modelOfCare),
            reviewers: data.organization.reviewers.map(reviewer =>
                convertKeysToSnakeCase(reviewer),
            ),
        },
        patientCodeStatus: convertKeysToSnakeCase(data.patientCodeStatus),
        problems: data.problems.map(problem => convertKeysToSnakeCase(problem)),
    };
};
